"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiLoadingIndicator = void 0;
const react_1 = require("react");
const React = require("react");
require("./loading-indicator.less");
class UiLoadingIndicator extends react_1.Component {
    render() {
        return (React.createElement("div", { className: `loading-indicator ${this.props.className}` },
            React.createElement("div", { className: "loading-indicator__bounce1" }),
            React.createElement("div", { className: "loading-indicator__bounce2" }),
            React.createElement("div", { className: "loading-indicator__bounce3" })));
    }
}
exports.UiLoadingIndicator = UiLoadingIndicator;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/loading-indicator/loading-indicator.tsx
// module id = 2177
// module chunks = 0 1 2